import { ButtonProps, HStack, Text } from '@chakra-ui/react';
import { FC, useMemo } from 'react';

import ActiveUpvoteIcon from '@/assets/icons/ic-thumb-up-active.svg';
import UpvoteIcon from '@/assets/icons/ic-thumb-up.svg';

import useSession from '@/hooks/useSession';
import { IConversationMessage } from '@/utils/conversation/types';

import { UpvoteButton } from '../NestedChatMessage.elements';

interface INestedChatMessageUpvoteProps extends ButtonProps {
  message: IConversationMessage;
}
export const NestedChatMessageUpvote: FC<INestedChatMessageUpvoteProps> = ({ message, ...props }) => {
  const { user } = useSession();

  const handleUpVote = () => {
    const currentAttributes = message?.attributes || {};
    const currentUpvotes = currentAttributes?.upvotes || [];

    if (!currentUpvotes.includes(user?.email)) {
      // not upvoted by current user
      message.updateAttributes({ ...currentAttributes, upvotes: [...currentUpvotes, user?.email] });
      return;
    }
    // upvoted by current user
    const updatedUpvotes = currentUpvotes.filter((identity) => identity !== user?.email);

    message.updateAttributes({ ...currentAttributes, upvotes: updatedUpvotes });
  };

  const isUpvoted = useMemo(() => {
    return message.attributes?.upvotes?.includes(user?.email);
  }, [message.attributes, user?.email]);

  return (
    <UpvoteButton type="button" variant="unstyled" aria-selected={isUpvoted} onClick={handleUpVote} {...props}>
      <HStack>
        {isUpvoted ? <ActiveUpvoteIcon width={24} height={24} /> : <UpvoteIcon width={24} height={24} />}
        <Text as="span" fontSize="sm" fontWeight="normal">
          {message.attributes?.upvotes?.length || 0}
        </Text>
      </HStack>
    </UpvoteButton>
  );
};
